import React from 'react';
import { HiChevronDown } from 'react-icons/hi';
import './Select.css';

const Select = ({
  value,
  onChange,
  options = [],
  placeholder = 'Selecione...',
  className = '',
  required = false,
  disabled = false,
  ...props
}) => {
  return (
    <div className={`custom-select-wrapper ${className}`}>
      <select
        value={value}
        onChange={onChange}
        className={`custom-select ${className.includes('field-invalid') ? 'field-invalid' : ''}`}
        required={required}
        disabled={disabled}
        {...props}
      >
        {placeholder && (
          <option value="" disabled>
            {placeholder}
          </option>
        )}
        {options.map((option) => {
          if (typeof option === 'string') {
            return (
              <option key={option} value={option}>
                {option}
              </option>
            );
          }
          return (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          );
        })}
      </select>
      <HiChevronDown className="select-arrow" />
    </div>
  );
};

export default Select;

